import { render, staticRenderFns } from "./ListarTurmaPage.vue?vue&type=template&id=6e2d9f38"
import script from "./ListarTurmaPage.vue?vue&type=script&lang=js"
export * from "./ListarTurmaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports